import moment from "moment";

const ProfTaxSlab = [
  {
    id: 1,
    salaryGrossFrom: 0,
    salaryGrossTo: 21000,
    amount: 0,
    remarks: "",
  },
  {
    id: 2,
    salaryGrossFrom: 21001,
    salaryGrossTo: 30000,
    amount: 190,
    remarks: "",
  },
  {
    id: 3,
    salaryGrossFrom: 30001,
    salaryGrossTo: 45000,
    amount: 460,
    remarks: "",
  },
  {
    id: 4,
    salaryGrossFrom: 45001,
    salaryGrossTo: 60000,
    amount: 920,
    remarks: "",
  },
  {
    id: 5,
    salaryGrossFrom: 60001,
    salaryGrossTo: 75000,
    amount: 1200,
    remarks: "",
  },
  {
    id: 6,
    salaryGrossFrom: 75001,
    salaryGrossTo: 900000,
    amount: 1250,
    remarks: "",
  },
];

// Function to get the tax amount based on the gross salary
// const getTaxAmount = (grossSalary) => {
//   for (const slab of ProfTaxSlab) {
//     const { salaryGross, amount } = slab;
//     if (salaryGross.includes("UPTO") && grossSalary <= 21000) {
//       return amount;
//     }
//     if (
//       salaryGross.includes("BETWEEN") &&
//       grossSalary > 21001 &&
//       grossSalary <= 30000
//     ) {
//       return amount;
//     }
//     if (
//       salaryGross.includes("BETWEEN") &&
//       grossSalary > 30001 &&
//       grossSalary <= 45000
//     ) {
//       return amount;
//     }
//     if (
//       salaryGross.includes("BETWEEN") &&
//       grossSalary > 45001 &&
//       grossSalary <= 60000
//     ) {
//       return amount;
//     }
//     if (salaryGross.includes("ABOVE") && grossSalary > 75001) {
//       return amount;
//     }
//   }
//   return 0; // Default to 0 if no slab matches
// };

const getTaxAmount = (grossSalary) => {
  for (const slab of ProfTaxSlab) {
    const { salaryGrossFrom, salaryGrossTo, amount } = slab;
    if (grossSalary >= salaryGrossFrom && grossSalary <= salaryGrossTo) {
        console.log(amount)
      return amount;
    }
  }
  return 0; // Default to 0 if no slab matches
};

// const getTaxAmount = (grossSalary) => {
//     for (const slab of ProfTaxSlab) {
//       const { salaryGross, amount } = slab;
  
//       if (salaryGross.includes("UPTO") && grossSalary <= 21000) {
//         return amount;
//       }
  
//       const betweenMatch = salaryGross.match(/BETWEEN (\d+) To (\d+)/i);
//       if (betweenMatch) {
//         const [_, lowerLimit, upperLimit] = betweenMatch.map(Number);
//         if (grossSalary > lowerLimit && grossSalary <= upperLimit) {
//           return amount;
//         }
//       }
  
//       if (salaryGross.includes("ABOVE") && grossSalary > 75001) {
//         return amount;
//       }
//     }
//     return 0; // Default to 0 if no condition matches
//   };
  


const calculateProRatedTax = (joiningDate, grossSalary) => {
  const joinDate = moment(joiningDate);
  const financialYearStart =
    joinDate.month() >= 3
      ? moment(joinDate.year(), "YYYY").month(3).startOf("month") // April 1st of the current year
      : moment(joinDate.year() - 1, "YYYY")
          .month(3)
          .startOf("month"); // April 1st of the previous year

  const financialYearEnd = moment(financialYearStart)
    .add(12, "months")
    .subtract(1, "day"); // March 31st
    const remainingMonths = financialYearEnd.diff(joinDate, "months") + 1; // Inclusive of the start month
    const totalGrossSlarayForTax = grossSalary*remainingMonths
    const taxAmount = getTaxAmount(totalGrossSlarayForTax);

  //   const proRatedTax = (taxAmount / 12) * remainingMonths;
  const proRatedTax = taxAmount / remainingMonths;

  return proRatedTax;
};

export { calculateProRatedTax, getTaxAmount };
